import React from 'react';
import { FormattedText } from 'core/i18n';
export const CreditCardInfo = ({ getPartnerId }) => (
    <FormattedText value={`documentation-creditCardInfo_${getPartnerId()}`} />
);
